// extracted by mini-css-extract-plugin
export default {"searchform":"_3jk40AUK7h-QG2dYMXJ1A3"};